import dayjs from "dayjs";
import { NEW_HIGHLIGHT_HOURS } from "./constants";
import type {
  PickEmptyStateVariant,
  ToDiagramSidebarItems,
  ToPlanSidebarItems,
} from "./types";

const isRecentlyCreated = (createdAt: string): boolean =>
  dayjs.utc().diff(dayjs.utc(createdAt), "hour") < NEW_HIGHLIGHT_HOURS;

export const toPlanSidebarItems: ToPlanSidebarItems = ({
  planRecords,
  planFilter,
}) =>
  planRecords
    .map((record, index) => ({
      key: record.id,
      label: record.name,
      index,
      createdAt: record.createdAt,
      isNew: isRecentlyCreated(record.createdAt),
      publishStatus: record.publishStatus,
      isArchived: record.archivedAt !== null,
      folderId: record.folderId,
    }))
    // Filter after mapping so `index` keeps pointing into planRecords.
    .filter((item) =>
      planFilter === "archived" ? item.isArchived : !item.isArchived,
    );

export const toDiagramSidebarItems: ToDiagramSidebarItems = ({
  diagramRecords,
}) => {
  const sourceFiles = new Set(
    diagramRecords
      .map((record) => record.distributionBoardFileName)
      .filter(Boolean),
  );
  const isMultiFile = sourceFiles.size > 1;

  return diagramRecords.map((record, index) => ({
    key: record.id,
    label: record.name,
    index,
    createdAt: record.createdAt,
    isNew: isRecentlyCreated(record.createdAt),
    sourceFile: isMultiFile ? record.distributionBoardFileName : undefined,
    folderId: null,
  }));
};

// Same page and query params; the new tab selects this plan from floorPlanId on load.
export const buildFloorPlanTabUrl = (floorPlanId: number): string => {
  const url = new URL(window.location.href);
  url.searchParams.set("floorPlanId", String(floorPlanId));
  return url.toString();
};

export const pickEmptyStateVariant: PickEmptyStateVariant = ({
  sidebarMode,
  planFilter,
  rowCount,
  hasPlans,
  isSearching,
}) => {
  if (rowCount > 0) return null;
  if (isSearching) return "noSearchResults";
  if (sidebarMode !== "plans") return null;
  if (planFilter === "archived") return "noArchivedPlans";
  return hasPlans ? "noActivePlans" : "noPlans";
};
